import script from "./SkuDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuDialog.vue?vue&type=script&setup=true&lang=js"

import "./SkuDialog.vue?vue&type=style&index=0&id=18b484d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b484d2"]])

export default __exports__